<app-list-header [headerName]="'Готовые уроки'"></app-list-header>
<app-lessons-list
  [lessonStatus]="lesson_created"
  [studentClassId]="classId"
  [showHeader]="false"
  *ngIf="classId && teacher">
</app-lessons-list>
